import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'

Vue.config.productionTip = false;

import router from './router';
import store from './store';

import VueAMap, { lazyAMapApiLoaderInstance } from 'vue-amap';
Vue.use(VueAMap);
console.log('VueAMap', VueAMap);
VueAMap.initAMapApiLoader({
    key: 'fa76d70a67bf401ca524d3a8a1f397ff',
    plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geocoder'],
    v: '1.4.4'
});

import VueAwesomeSwiper from 'vue-awesome-swiper'

import * as filters from './filter'

import 'swiper/dist/css/swiper.css'
import '@/assets/font/iconfont.css'

Vue.use(VueAwesomeSwiper, /* {default global options} */ )
Vue.use(ElementUI);


Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');